<template>
<div>
    <el-dialog class="doc_send_dialog" title="发送文书" width="60%" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" :before-close="recordClose" center>
        <div class="doc_send_wrap">
            <el-form :model="docsendForm" ref="docsendForm" label-position="left" label-width="100px" size="small" :hide-required-asterisk="true">
                <el-form-item label="选择文书类型">
                    <el-select v-model="docsendForm.type" style="width:450px;" placeholder="请选择">
                        <el-option v-for="item in typeOptions" :key="item.docType" :label="item.docName" :value="item.docType">
                        </el-option>
                    </el-select>
                    <a v-if="docsendForm.type != 'TRIAL_RECORD' && docsendForm.type != 'OTHER'" class="doc_template" @click="downLoadTemplate">点击下载模板</a>
                </el-form-item>
              <el-form-item v-if="docsendForm.type == 'OTHER'" label="文书名称" prop="docName">
                <el-input style="width: 47.5%" v-model="docsendForm.docName"></el-input>
              </el-form-item>
                <el-form-item v-if="docsendForm.type != 'TRIAL_RECORD'" label="选择文件" prop="fileName">
                    <el-row>
                        <el-col :span="16">
                            <el-input v-model="docsendForm.fileName" placeholder="请上传文书" clearable @clear="handleClearFile"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <el-upload class="upload-doc" ref="upload" :action="fileUploads.actionUrl" :accept="fileUploads.acceptType" :headers="fileUploads.flk" :http-request="handleRequestRecord" :on-remove="handleRemove" :on-change="handleChange" :show-file-list="false" :auto-upload="false">
                                <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
                            </el-upload>
                        </el-col>
                    </el-row>
                    <div class="el-upload__tip">只能上传pdf/doc/docx文件，{{maxFileTip}}</div>
                </el-form-item>
                <iframe title="庭审笔录" :src="fileUrl" v-else></iframe>
            </el-form>
        </div>
        <div v-if="docsendForm.type != 'TRIAL_RECORD'" slot="footer" class="dialog-footer">
            <el-button @click="recordClose(null)">取 消</el-button>
            <el-button type="primary" :loading="BtnLoading" @click="handleSendBook(0)">发送</el-button>
        </div>
        <div v-else slot="footer" class="dialog-footer">
            <el-button @click="downLoadDoc" style="width: 140px">下载并重新上传</el-button>
            <el-button type="primary" :loading="BtnLoading" @click="sendTSBook">提交签字</el-button>
        </div>
    </el-dialog>
<el-dialog class="doc_send_dialog"  title="发送文书" :close-on-click-modal=false :visible.sync="showUploadTSDoc" :append-to-body="true" :before-close="recordClose" center>
    <div class="doc_send_wrap">
        <el-form :model="docsendForm" ref="docsendForm" label-position="left" label-width="100px" size="small" :hide-required-asterisk="true">
            <el-form-item label="">
                <h2 style="font-size:16px;">下载系统自动生成文书，本地修改后上传，发送后将自动附上签字</h2>
                未找到下载文书？<a class="doc_template" target="_blank" :href="clerkRecordDownloadUrl">点击下载模板</a>
            </el-form-item>
            <el-form-item label="选择文件" prop="fileName">
                <el-row>
                    <el-col :span="16">
                        <el-input v-model="docsendForm.fileName" placeholder="请上传文书" clearable @clear="handleClearFile"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <el-upload class="upload-doc" ref="upload" :action="fileUploads.actionUrl" :accept="fileUploads.acceptType" :headers="fileUploads.flk" :http-request="handleRequestRecord" :on-remove="handleRemove" :on-change="handleChange" :show-file-list="false" :auto-upload="false">
                            <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
                <div class="el-upload__tip">只能上传pdf/doc/docx文件，{{maxFileTip}}</div>
            </el-form-item>
        </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="showUploadTSDoc = false">取 消</el-button>
        <el-button type="primary" :loading="BtnLoading" @click="handleSendBook(1)">发送</el-button>
    </div>
</el-dialog>
</div>


</template>

<script>
import {
    sendDocBook,
    getMediationRoomUserInfoList,
    queryDocTempList,
    createClerkRecord,
    sendClerkRecordGzzc
} from "@/api/casespace_doclist.js";
import {
  getFileExtendName,
  getStore, toastSuc, toastWarning
} from '@/utils/utils.js'
import config from '@/config/config.js'
import {maxFileLength, maxFileWarning, maxFileTip} from "../../../utils/utils";
export default {
    props: ['wsLink', 'currentRoomId'],
    data() {
        return {
            dialogVisible: false,
            maxFileTip: maxFileTip,
            docsendForm: {
                resource: "2",
                type: "TRIAL_RECORD",
                fileName: "",
                files: null,
              docName:''  //其他  文书名称
            },
            typeOptions: [],
            //模板下载地址
            templateUrl: '',
            fileUploads: {
                actionUrl: `${config.baseURL}/gzzc/docBook/upload`,
                acceptType: '.pdf,.doc,.docx',
                flk: {
                    JWTToken: getStore('flk'),
                    appName: config.appName,
                    cType: 'PC'
                },
                fileData: {
                    isView: 'NOVIEW'
                },
                fileList: "",
                fileJson: []
            },
            buttonStatus: false,
            BtnLoading: false,
            curCaseId: null,
            curMeetingId: null,
            curRoomUserList: {},
            curRoomUserIdList: [],
            docObj: {},
            fileUrl: '',
            clerkRecordDownloadUrl:'',
            showUploadTSDoc: false,
        }
    },
    created() {
        this.curCaseId = this.$route.query.caseid
        this.curMeetingId = this.$route.query.meetingid
    },
    methods: {
        openDocDialog() {
            console.log('opendialog-----')
            let userData = {}
            this.getDocTempList()
            getMediationRoomUserInfoList({
                "id": this.curCaseId
            }).then(res => {
                if (res.data.code === 1000) {
                    res.data.data.forEach(element => {
                        userData[element.userId] = element
                    })
                    this.curRoomUserList = userData
                    this.curRoomUserIdList = res.data.data.map(item => {
                        return {
                            id: item.userId,
                            name: item.userName
                        }
                    })
                }
                this.dialogVisible = true
            }, err => {
                this.dialogVisible = true
            })
        },
        recordClose(done) {
            this.$refs["docsendForm"].resetFields();
            done ? done() : this.dialogVisible = false
        },
        //获取笔录模板
        getDocTempList() {
            queryDocTempList({
                "onlineStatus": 1,
                "pageIndex": 1,
                "bizCode": 'gzzc_ts',
                "pageSize": 200
            }).then(res => {
                if (res.data.code === 1000) {
                    if (res.data.data.list.length > 0) {
                        this.typeOptions = res.data.data.list
                    }
                }
            })
        },
        handleRemove(file, fileList) {
            //删除文件（上传）
            this.fileUploads.fileList = fileList
        },
        handleChange(file, fileList) {
            if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            let tempRet = /\.[^.]+$/.exec(file.name)
            let isAcceptType = true
            if (tempRet) {
                if (!~this.fileUploads.acceptType.indexOf(tempRet[0])) {
                    isAcceptType = false
                }
            }
            if (!isAcceptType) {
                this.$message({
                    type: 'warning',
                    message: '文件只支持' + this.fileUploads.acceptType + '等格式'
                });
                fileList.pop()
                return
            }
            if (tempRet.index > 20) {
                this.$message({
                    type: 'warning',
                    message: '文件名不超过20个字符长度'
                })
                return false
            }
            this.docsendForm.fileName = file.name
        },
        handleRequestRecord(file) {
            console.log('file:', file)
            this.docsendForm.files = file.file
        },
        handleClearFile() {
            this.$refs.upload.clearFiles()
        },
        handleSendBook(dtype) {
            let self = this
            self.$refs.upload.submit();
            console.log(3333)
            let params = new FormData()
            params.append('docId', '')
            params.append('meetingId', self.curMeetingId)
            params.append('caseId', self.curCaseId)
          if(this.docsendForm.type == 'OTHER'){
            if(this.docsendForm.docName=='') {
              toastWarning('请输入文书名')
              return;
            }else
              params.append('fileName', this.docsendForm.docName+'.'+getFileExtendName(self.docsendForm.fileName))
          }else {
            params.append('fileName', self.docsendForm.fileName)
          }
            if (self.docsendForm.files) {
                params.append('uploadFile', self.docsendForm.files)
            } else {
                this.$message.warning('请上传文书')
                return
            }


            self.BtnLoading = true
            params.append('docType', dtype == 0 ? self.docsendForm.type : 'TRIAL_RECORD')
            console.log(params)
            sendDocBook(params).then(res => {
                console.log(res)
                if (res.data.code === 1000) {
                    // self.compontCallback({
                    //     fileId: res.data.data.fileId,
                    //     docsendtype: self.docsendForm.type,
                    //     docId: res.data.data.docId,
                    //     attachId: res.data.data.attachId,
                    //     fileName: res.data.data.fileName,
                    //     filePath: res.data.data.filePath
                    // })
                    self.$refs["docsendForm"].resetFields();
                    self.dialogVisible = false
                    self.showUploadTSDoc = false
                    self.$emit('loadPage')
                } else {
                    self.$message({
                        message: res.data.message,
                        type: 'error'
                    })
                }
                self.BtnLoading = false
            }, err => {
                self.BtnLoading = false
            })
        },
        downLoadTemplate() {
            let result = this.typeOptions.find(item => {
                return item.docType === this.docsendForm.type
            })
            let temp = result.docTemp
            console.log('没有key会报错', temp)
            if (temp && temp.value) {
                let url = temp.value
                console.log('下载url-----', url)
                window.open(url)
                // let name = temp.desc + '模版.doc'
                // filedownload('/pisces/file/clerkModelDownload', {
                //     url: url,
                // }, name)
            } else {
                console.log('weishameizou')
                this.$message({
                    message: "暂无模版,请于管理平台上传模版",
                    type: 'error'
                })
            }
        },
        //创建庭审笔录
        createDocument() {
            let params = {
                meetId: this.curMeetingId
            }
            createClerkRecord(params).then(res => {
                console.log("########", res)
                if (res.data.code === 1000) {
                    this.fileUrl = res.data.data.clerkRecordPdfUrl
                    this.documentId = res.data.data.documentId
                    this.clerkRecordDownloadUrl = res.data.data.clerkRecordDownloadUrl
                }
            })
        },
        //下载笔录
        downLoadDoc() {
            // clerkRecordDownloadUrl(this.documentId).then(res => {
            //     console.log("########", res)
            //     let url = window.URL.createObjectURL(new Blob([res.data],{
            //         type: 'application/force-download;charset=GBK'
            //     }))
            //     let link = document.createElement('a')
            //     link.style.display = 'none'
            //     link.href = url
            //     link.setAttribute('download', 'document.doc')
            //     document.body.appendChild(link)
            //     link.click();
            //     link.remove();
            // })
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = this.clerkRecordDownloadUrl
                link.setAttribute('download', 'document.doc')
                document.body.appendChild(link)
                link.click();
                link.remove();
                this.dialogVisible = false
                this.showUploadTSDoc = true
        },
        sendTSBook(){
            sendClerkRecordGzzc({meetId: Number(this.curMeetingId), docId: this.documentId}).then(res => {
                if(res.data.code == 1000){
                    this.$message.success('发送成功')
                    this.dialogVisible = false
                    // this.compontCallback({
                    //     fileId: res.data.data.fileId,
                    //     docsendtype: 'TRIAL_RECORD',
                    //     docId: res.data.data.docId,
                    //     attachId: res.data.data.attachId,
                    //     fileName: res.data.data.fileName,
                    //     filePath: res.data.data.filePath
                    // })
                    this.$emit('loadPage')
                }else{
                    this.$message.error('发送失败')
                }
            })
        },
        //发送笔录文书
        compontCallback(obj) {
            let data = {
                roomId: this.currentRoomId,
                filePath: obj.filePath,
                categoryBig: 'DOCUMENT'
            }
            this.attachId = obj.attachId
            data = Object.assign(data, obj)
            let msgdata = {};
            msgdata.event = "SEND_BOOK";
            msgdata.data = data;
            console.log('发送文书:', msgdata)
            this.wsLink.send(JSON.stringify(msgdata))
            let data2 = {
                roomId: this.currentRoomId,
                messageType: 'DOCUMENT_INFO',
                categoryBig: 'DOCUMENT', //非必填
                messageResource: 'SYSTEM_AUTO_INPUT',
                content: JSON.stringify({
                    fileName: obj.fileName,
                    attachId: obj.attachId,
                    docId: obj.docId, //小程序签名使用
                    docsendtype: obj.docsendtype,
                    filePath: obj.filePath,
                    receiver: obj.receivers,
                    source: obj.source
                })
            }
            let msgdata2 = {};
            msgdata2.event = "SEND_MESSAGE";
            msgdata2.data = data2;
            console.log("发送", msgdata2)
            this.wsLink.send(JSON.stringify(msgdata2))
        }
    },
    watch: {
        dialogVisible(newVal, oldVal) {
            if (newVal) {
                this.createDocument()
            }
        }
    }
}
</script>

<style lang="scss">
.doc_send_dialog {
    .el-dialog__body {
        padding: 25px 25px 0;
    }

    .doc_send_wrap {
        margin: 0 25px;

        .doc_template {
            margin-left: 15px;
            text-decoration: underline;
            color: #428BC6;
            cursor: pointer;
        }

        iframe {
            width: 750px;
            height: 600px;
            border: 0;
            border: 1px solid #efefef;
        }

        .upload-doc {
            .el-upload {
                width: 100%;
                text-align: left;
                padding-left: 8px;
            }
        }

        .doc_type {
            width: 100%;
        }
    }

    .dialog-footer {
        padding-bottom: 20px;

        .el-button {
            width: 120px;
            height: 40px;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }

    .el-dialog {
        margin-top: 5vh !important;
    }
}
</style>
